<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 38c-8.66 0-15.61-7.16-18.92-13.29a1.49 1.49 0 010-1.42C8.39 17.16 15.34 10 24 10s15.61 7.16 18.92 13.29a1.49 1.49 0 010 1.42C39.61 30.84 32.66 38 24 38zM8.12 24C11.17 29.23 17 35 24 35s12.83-5.77 15.88-11C36.83 18.77 31 13 24 13S11.17 18.77 8.12 24z"/><path d="M24 33a9 9 0 119-9 9 9 0 01-9 9zm0-15a6 6 0 106 6 6 6 0 00-6-6z"/></svg>